
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artifacts",
      function () {
        return require("private-next-pages/artifacts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artifacts"])
      });
    }
  